<template>
    <div>
        <ui-select
            :icon="icon"
            :label="label"
            :keys="{ label:'name', value: 'id' }"
            :invalid="invalid"
            :error="error"
            :options="options"
            :disabled="isLoading"
            v-model="selected"
            :placeholder="placeholder"
            @change="handleChange"
            has-search
        ></ui-select>
    </div>
</template>

<script>    
    import { ReferralSourceResource } from '../../../classes/Api/Contact'

    export default {
        props: {
            icon: {
                type: String,
            },
            label: {
                type: String,
            },
            value: {
                type: Object,
            },
            invalid: {
                type: Boolean,
                default: false
            },
            error: {
                type: String
            },
            placeholder: {
                type: String
            }
        },
        watch: {
            value(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.selected = newVal;
                }
            }
        },
        data() {
            return {
                selected: {},
                options: [],
                isLoading: true,
            }
        },
        mounted() {
            this.isLoading = true;

            this.selected = this.value

            ReferralSourceResource.all().then(response => {
                this.isLoading = false;

                this.options = response.data;
            })
        },
        methods: {
            handleChange(e) {
                this.$emit('input', e);
            }
        }
    }
</script>